import { GlobalFilter } from "modules/filters/context/filterContext";
export const hasGlobalFilterValues = (globalFilter?: GlobalFilter) =>
  globalFilter
    ? Object.values(globalFilter).some((filter) =>
        typeof filter === "string" ? filter.length > 0 : filter
      )
    : false;

export default hasGlobalFilterValues;
